import { Button, toast } from '@westhetics/ui'
import { saveFile } from '@/features/patients/download'
import { errorMessage } from '@/lib/errors'
import { useBlankQuestionnairePdf } from './api'

/**
 * "Imprimir ficha em branco" (RN-ANA-24, P-ANA-10): baixa o questionário vigente da clínica como
 * PDF, para a paciente preencher à caneta. Na ficha da paciente, nome e CPF dela já saem impressos.
 * O que é preenchido no papel não entra no sistema; quem quer prova usa o link.
 */
export function PrintBlankFormButton({ patientId }: { patientId?: string }) {
  const pdf = useBlankQuestionnairePdf()

  function download() {
    pdf.mutate(patientId, {
      onSuccess: (file) => saveFile(file, 'anamnese-em-branco.pdf'),
      onError: (error) => toast(errorMessage(error)),
    })
  }

  return (
    <Button
      variant="outline"
      size="sm"
      loading={pdf.isPending}
      loadingLabel="Preparando a ficha…"
      onClick={download}
    >
      Imprimir ficha em branco
    </Button>
  )
}
